import { EventManagementData } from '@front-app/services/EventsApi/EventModel';
import { GroupsStore } from '@front-app/store/singletons/Groups';
import { SelectBoxChoice } from '@front-app/components/inputs/SelectBoxModel';

export function getAvailableGroups(event: EventManagementData | undefined): SelectBoxChoice[] {
	const groupsStore = GroupsStore.getInstance();

	if (!event) {
		return [];
	}

	// Filter the groups available to the user
	return event.groupIds
		.filter((id) => groupsStore.isGroupPresent(id))
		.map((id) => {
			const group = groupsStore.groupById(id);
			return {
				key: group.id,
				label: group.name,
			};
		});
}
